/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import * as Yup from 'yup';

export const imprintConfigValidationSchema = Yup.object({
  imprint: Yup.string().required('empty'),
});
